declare namespace $ {

	type $shm_button_copy__title_shm_dashboard_admin_user_dashboards_1 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['active_user_id'] >
		,
		ReturnType< $shm_button_copy['title'] >
	>
	type $shm_button_copy__hint_shm_dashboard_admin_user_dashboards_2 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_button_copy['hint'] >
	>
	type $shm_button_copy__text_shm_dashboard_admin_user_dashboards_3 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['active_user_id'] >
		,
		ReturnType< $shm_button_copy['text'] >
	>
	type $shm_button_copy__title_shm_dashboard_admin_user_dashboards_4 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['active_user_email'] >
		,
		ReturnType< $shm_button_copy['title'] >
	>
	type $shm_button_copy__hint_shm_dashboard_admin_user_dashboards_5 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_button_copy['hint'] >
	>
	type $shm_button_copy__text_shm_dashboard_admin_user_dashboards_6 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['active_user_email'] >
		,
		ReturnType< $shm_button_copy['text'] >
	>
	type $mol_switch__value_shm_dashboard_admin_user_dashboards_7 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['section_mode'] >
		,
		ReturnType< $mol_switch['value'] >
	>
	type $mol_switch__options_shm_dashboard_admin_user_dashboards_8 = $mol_type_enforce<
		({ 
			'monitoring': string,
			'mention_stats': string,
			'wordstat': string,
			'agent': string,
			'logs': string,
		}) 
		,
		ReturnType< $mol_switch['options'] >
	>
	type $mol_select__value_shm_dashboard_admin_user_dashboards_9 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['selected_user_id'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__dictionary_shm_dashboard_admin_user_dashboards_10 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['user_options'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_labeler__title_shm_dashboard_admin_user_dashboards_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_dashboard_admin_user_dashboards_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_13 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['section_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_ba_user_settings__user_id_shm_dashboard_admin_user_dashboards_14 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['active_user_id'] >
		,
		ReturnType< $shm_ba_user_settings['user_id'] >
	>
	type $shm_ba_user_settings__user_data_shm_dashboard_admin_user_dashboards_15 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['active_user_data'] >
		,
		ReturnType< $shm_ba_user_settings['user_data'] >
	>
	type $shm_ba_user_settings__scope_shm_dashboard_admin_user_dashboards_16 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_ba_user_settings['scope'] >
	>
	type $mol_button_major__title_shm_dashboard_admin_user_dashboards_17 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__enabled_shm_dashboard_admin_user_dashboards_18 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['dashboard_create_enabled'] >
		,
		ReturnType< $mol_button_major['enabled'] >
	>
	type $mol_button_major__click_shm_dashboard_admin_user_dashboards_19 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['dashboard_create'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_search__query_shm_dashboard_admin_user_dashboards_20 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['dashboard_query'] >
		,
		ReturnType< $mol_search['query'] >
	>
	type $mol_search__hint_shm_dashboard_admin_user_dashboards_21 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_search['hint'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_22 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['dashboard_toolbar_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_shm_dashboard_admin_user_dashboards_23 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['body_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $shm_ba_user_settings__user_id_shm_dashboard_admin_user_dashboards_24 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['active_user_id'] >
		,
		ReturnType< $shm_ba_user_settings['user_id'] >
	>
	type $shm_ba_user_settings__user_data_shm_dashboard_admin_user_dashboards_25 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['active_user_data'] >
		,
		ReturnType< $shm_ba_user_settings['user_data'] >
	>
	type $shm_ba_user_settings__scope_shm_dashboard_admin_user_dashboards_26 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_ba_user_settings['scope'] >
	>
	type $mol_button_major__title_shm_dashboard_admin_user_dashboards_27 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_shm_dashboard_admin_user_dashboards_28 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['mention_stats_create'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_string_button__value_shm_dashboard_admin_user_dashboards_29 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['mention_stats_task_title_draft'] >
		,
		ReturnType< $mol_string_button['value'] >
	>
	type $mol_string_button__submit_shm_dashboard_admin_user_dashboards_30 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['mention_stats_task_title_commit'] >
		,
		ReturnType< $mol_string_button['submit'] >
	>
	type $mol_string_button__event_shm_dashboard_admin_user_dashboards_31 = $mol_type_enforce<
		({ 
			blur( next?: ReturnType< $shm_dashboard_admin_user_dashboards['mention_stats_task_title_commit'] > ): ReturnType< $shm_dashboard_admin_user_dashboards['mention_stats_task_title_commit'] >,
			keydown( next?: ReturnType< $shm_dashboard_admin_user_dashboards['mention_stats_task_title_keydown'] > ): ReturnType< $shm_dashboard_admin_user_dashboards['mention_stats_task_title_keydown'] >,
		})  & ReturnType< $mol_string_button['event'] >
		,
		ReturnType< $mol_string_button['event'] >
	>
	type $mol_button_minor__title_shm_dashboard_admin_user_dashboards_32 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_dashboard_admin_user_dashboards_33 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['mention_stats_task_open'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_34 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__title_shm_dashboard_admin_user_dashboards_35 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_dashboard_admin_user_dashboards_36 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['mention_stats_task_delete'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_shm_dashboard_admin_user_dashboards_37 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_dashboard_admin_user_dashboards_38 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['mention_stats_task_delete_cancel'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_39 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_pick__align_shm_dashboard_admin_user_dashboards_40 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['align'] >
	>
	type $mol_pick__showed_shm_dashboard_admin_user_dashboards_41 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['mention_stats_task_delete_showed'] >
		,
		ReturnType< $mol_pick['showed'] >
	>
	type $mol_pick__hint_shm_dashboard_admin_user_dashboards_42 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['hint'] >
	>
	type $mol_pick__trigger_content_shm_dashboard_admin_user_dashboards_43 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['trigger_content'] >
	>
	type $mol_pick__bubble_content_shm_dashboard_admin_user_dashboards_44 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	type $mol_string_button__value_shm_dashboard_admin_user_dashboards_45 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['dashboard_title_draft'] >
		,
		ReturnType< $mol_string_button['value'] >
	>
	type $mol_string_button__submit_shm_dashboard_admin_user_dashboards_46 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['dashboard_title_commit'] >
		,
		ReturnType< $mol_string_button['submit'] >
	>
	type $mol_string_button__event_shm_dashboard_admin_user_dashboards_47 = $mol_type_enforce<
		({ 
			blur( next?: ReturnType< $shm_dashboard_admin_user_dashboards['dashboard_title_commit'] > ): ReturnType< $shm_dashboard_admin_user_dashboards['dashboard_title_commit'] >,
			keydown( next?: ReturnType< $shm_dashboard_admin_user_dashboards['dashboard_title_keydown'] > ): ReturnType< $shm_dashboard_admin_user_dashboards['dashboard_title_keydown'] >,
		})  & ReturnType< $mol_string_button['event'] >
		,
		ReturnType< $mol_string_button['event'] >
	>
	type $shm_button_open__title_shm_dashboard_admin_user_dashboards_48 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['csv_to_duckdb_title'] >
		,
		ReturnType< $shm_button_open['title'] >
	>
	type $shm_button_open__enabled_shm_dashboard_admin_user_dashboards_49 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['csv_to_duckdb_enabled'] >
		,
		ReturnType< $shm_button_open['enabled'] >
	>
	type $shm_button_open__accept_shm_dashboard_admin_user_dashboards_50 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_button_open['accept'] >
	>
	type $shm_button_open__multiple_shm_dashboard_admin_user_dashboards_51 = $mol_type_enforce<
		boolean
		,
		ReturnType< $shm_button_open['multiple'] >
	>
	type $shm_button_open__files_shm_dashboard_admin_user_dashboards_52 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['csv_to_duckdb_files'] >
		,
		ReturnType< $shm_button_open['files'] >
	>
	type $mol_list__rows_shm_dashboard_admin_user_dashboards_53 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['dashboard_user_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_pick__align_shm_dashboard_admin_user_dashboards_54 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['align'] >
	>
	type $mol_pick__showed_shm_dashboard_admin_user_dashboards_55 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['dashboard_access_showed'] >
		,
		ReturnType< $mol_pick['showed'] >
	>
	type $mol_pick__auto_shm_dashboard_admin_user_dashboards_56 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['auto'] >
	>
	type $mol_pick__trigger_content_shm_dashboard_admin_user_dashboards_57 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['trigger_content'] >
	>
	type $mol_pick__bubble_content_shm_dashboard_admin_user_dashboards_58 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	type $mol_button_major__title_shm_dashboard_admin_user_dashboards_59 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['dashboard_tags_rebuild_title'] >
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__enabled_shm_dashboard_admin_user_dashboards_60 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['dashboard_tags_rebuild_enabled'] >
		,
		ReturnType< $mol_button_major['enabled'] >
	>
	type $mol_button_major__click_shm_dashboard_admin_user_dashboards_61 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['dashboard_tags_rebuild'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_list__rows_shm_dashboard_admin_user_dashboards_62 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['dashboard_tag_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_pick__align_shm_dashboard_admin_user_dashboards_63 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['align'] >
	>
	type $mol_pick__showed_shm_dashboard_admin_user_dashboards_64 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['dashboard_tags_showed'] >
		,
		ReturnType< $mol_pick['showed'] >
	>
	type $mol_pick__auto_shm_dashboard_admin_user_dashboards_65 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['auto'] >
	>
	type $mol_pick__trigger_content_shm_dashboard_admin_user_dashboards_66 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['trigger_content'] >
	>
	type $mol_pick__bubble_content_shm_dashboard_admin_user_dashboards_67 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_68 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__title_shm_dashboard_admin_user_dashboards_69 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_dashboard_admin_user_dashboards_70 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['dashboard_delete'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_shm_dashboard_admin_user_dashboards_71 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_dashboard_admin_user_dashboards_72 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['dashboard_delete_cancel'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_73 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_pick__align_shm_dashboard_admin_user_dashboards_74 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['align'] >
	>
	type $mol_pick__showed_shm_dashboard_admin_user_dashboards_75 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['dashboard_delete_showed'] >
		,
		ReturnType< $mol_pick['showed'] >
	>
	type $mol_pick__auto_shm_dashboard_admin_user_dashboards_76 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['auto'] >
	>
	type $mol_pick__trigger_content_shm_dashboard_admin_user_dashboards_77 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['trigger_content'] >
	>
	type $mol_pick__bubble_content_shm_dashboard_admin_user_dashboards_78 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_79 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_shm_dashboard_admin_user_dashboards_80 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['upload_tag_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_button_major__title_shm_dashboard_admin_user_dashboards_81 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_shm_dashboard_admin_user_dashboards_82 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['upload_confirm'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_minor__title_shm_dashboard_admin_user_dashboards_83 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_dashboard_admin_user_dashboards_84 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['upload_cancel'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_85 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_string_button__value_shm_dashboard_admin_user_dashboards_86 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['file_title_draft'] >
		,
		ReturnType< $mol_string_button['value'] >
	>
	type $mol_string_button__submit_shm_dashboard_admin_user_dashboards_87 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['file_title_commit'] >
		,
		ReturnType< $mol_string_button['submit'] >
	>
	type $mol_string_button__event_shm_dashboard_admin_user_dashboards_88 = $mol_type_enforce<
		({ 
			blur( next?: ReturnType< $shm_dashboard_admin_user_dashboards['file_title_commit'] > ): ReturnType< $shm_dashboard_admin_user_dashboards['file_title_commit'] >,
			keydown( next?: ReturnType< $shm_dashboard_admin_user_dashboards['file_title_keydown'] > ): ReturnType< $shm_dashboard_admin_user_dashboards['file_title_keydown'] >,
		})  & ReturnType< $mol_string_button['event'] >
		,
		ReturnType< $mol_string_button['event'] >
	>
	type $mol_view__attr_shm_dashboard_admin_user_dashboards_89 = $mol_type_enforce<
		({ 
			'title': ReturnType< $shm_dashboard_admin_user_dashboards['file_name'] >,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_90 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_91 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_92 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_93 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_button_open__title_shm_dashboard_admin_user_dashboards_94 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['file_append_title'] >
		,
		ReturnType< $shm_button_open['title'] >
	>
	type $shm_button_open__enabled_shm_dashboard_admin_user_dashboards_95 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['file_append_enabled'] >
		,
		ReturnType< $shm_button_open['enabled'] >
	>
	type $shm_button_open__accept_shm_dashboard_admin_user_dashboards_96 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_button_open['accept'] >
	>
	type $shm_button_open__multiple_shm_dashboard_admin_user_dashboards_97 = $mol_type_enforce<
		boolean
		,
		ReturnType< $shm_button_open['multiple'] >
	>
	type $shm_button_open__files_shm_dashboard_admin_user_dashboards_98 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['file_append_files'] >
		,
		ReturnType< $shm_button_open['files'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_99 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_string__value_shm_dashboard_admin_user_dashboards_100 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['auto_update_daily_draft'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__hint_shm_dashboard_admin_user_dashboards_101 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_labeler__title_shm_dashboard_admin_user_dashboards_102 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_dashboard_admin_user_dashboards_103 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_string__value_shm_dashboard_admin_user_dashboards_104 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['auto_update_weekly_draft'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__hint_shm_dashboard_admin_user_dashboards_105 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_labeler__title_shm_dashboard_admin_user_dashboards_106 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_dashboard_admin_user_dashboards_107 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_string__value_shm_dashboard_admin_user_dashboards_108 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['auto_update_monthly_draft'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__hint_shm_dashboard_admin_user_dashboards_109 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_labeler__title_shm_dashboard_admin_user_dashboards_110 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_dashboard_admin_user_dashboards_111 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_button_major__title_shm_dashboard_admin_user_dashboards_112 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__enabled_shm_dashboard_admin_user_dashboards_113 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['auto_update_save_enabled'] >
		,
		ReturnType< $mol_button_major['enabled'] >
	>
	type $mol_button_major__click_shm_dashboard_admin_user_dashboards_114 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['auto_update_save'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_minor__title_shm_dashboard_admin_user_dashboards_115 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__enabled_shm_dashboard_admin_user_dashboards_116 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['auto_update_run_enabled'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_shm_dashboard_admin_user_dashboards_117 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['auto_update_run'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_shm_dashboard_admin_user_dashboards_118 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__enabled_shm_dashboard_admin_user_dashboards_119 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['auto_update_disable_enabled'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_shm_dashboard_admin_user_dashboards_120 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['auto_update_disable'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_121 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_122 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_dashboard_admin_user_dashboards_auto_update__showed_shm_dashboard_admin_user_dashboards_123 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['auto_update_showed'] >
		,
		ReturnType< $shm_dashboard_admin_user_dashboards_auto_update['showed'] >
	>
	type $shm_dashboard_admin_user_dashboards_auto_update__auto_shm_dashboard_admin_user_dashboards_124 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_dashboard_admin_user_dashboards_auto_update['auto'] >
	>
	type $shm_dashboard_admin_user_dashboards_auto_update__trigger_content_shm_dashboard_admin_user_dashboards_125 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_dashboard_admin_user_dashboards_auto_update['trigger_content'] >
	>
	type $shm_dashboard_admin_user_dashboards_auto_update__bubble_content_shm_dashboard_admin_user_dashboards_126 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_dashboard_admin_user_dashboards_auto_update['bubble_content'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_127 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__title_shm_dashboard_admin_user_dashboards_128 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_dashboard_admin_user_dashboards_129 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['file_delete'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_shm_dashboard_admin_user_dashboards_130 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_dashboard_admin_user_dashboards_131 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['file_delete_cancel'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_132 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_pick__align_shm_dashboard_admin_user_dashboards_133 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['align'] >
	>
	type $mol_pick__showed_shm_dashboard_admin_user_dashboards_134 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['file_delete_showed'] >
		,
		ReturnType< $mol_pick['showed'] >
	>
	type $mol_pick__auto_shm_dashboard_admin_user_dashboards_135 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['auto'] >
	>
	type $mol_pick__trigger_content_shm_dashboard_admin_user_dashboards_136 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['trigger_content'] >
	>
	type $mol_pick__bubble_content_shm_dashboard_admin_user_dashboards_137 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_138 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_139 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_140 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_141 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_142 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_143 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_144 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_145 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_146 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_major__title_shm_dashboard_admin_user_dashboards_147 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_shm_dashboard_admin_user_dashboards_148 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['wordstat_create'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_149 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_150 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_151 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_152 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_153 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_154 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_shm_dashboard_admin_user_dashboards_155 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['wordstat_task_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_string_button__value_shm_dashboard_admin_user_dashboards_156 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['wordstat_task_title_draft'] >
		,
		ReturnType< $mol_string_button['value'] >
	>
	type $mol_string_button__submit_shm_dashboard_admin_user_dashboards_157 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['wordstat_task_title_commit'] >
		,
		ReturnType< $mol_string_button['submit'] >
	>
	type $mol_string_button__event_shm_dashboard_admin_user_dashboards_158 = $mol_type_enforce<
		({ 
			blur( next?: ReturnType< $shm_dashboard_admin_user_dashboards['wordstat_task_title_commit'] > ): ReturnType< $shm_dashboard_admin_user_dashboards['wordstat_task_title_commit'] >,
			keydown( next?: ReturnType< $shm_dashboard_admin_user_dashboards['wordstat_task_title_keydown'] > ): ReturnType< $shm_dashboard_admin_user_dashboards['wordstat_task_title_keydown'] >,
		})  & ReturnType< $mol_string_button['event'] >
		,
		ReturnType< $mol_string_button['event'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_159 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_160 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_161 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_check_box__title_shm_dashboard_admin_user_dashboards_162 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_dashboard_admin_user_dashboards_163 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['wordstat_task_daily'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_button_minor__title_shm_dashboard_admin_user_dashboards_164 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_dashboard_admin_user_dashboards_165 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['wordstat_task_open'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_166 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__title_shm_dashboard_admin_user_dashboards_167 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_dashboard_admin_user_dashboards_168 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['wordstat_task_delete'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_shm_dashboard_admin_user_dashboards_169 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_dashboard_admin_user_dashboards_170 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['wordstat_task_delete_cancel'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_171 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_pick__align_shm_dashboard_admin_user_dashboards_172 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['align'] >
	>
	type $mol_pick__showed_shm_dashboard_admin_user_dashboards_173 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['wordstat_task_delete_showed'] >
		,
		ReturnType< $mol_pick['showed'] >
	>
	type $mol_pick__hint_shm_dashboard_admin_user_dashboards_174 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['hint'] >
	>
	type $mol_pick__trigger_content_shm_dashboard_admin_user_dashboards_175 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['trigger_content'] >
	>
	type $mol_pick__bubble_content_shm_dashboard_admin_user_dashboards_176 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_177 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_178 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_179 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_180 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_181 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['mention_stats_content_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_ba_user_settings__user_id_shm_dashboard_admin_user_dashboards_182 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['active_user_id'] >
		,
		ReturnType< $shm_ba_user_settings['user_id'] >
	>
	type $shm_ba_user_settings__user_data_shm_dashboard_admin_user_dashboards_183 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['active_user_data'] >
		,
		ReturnType< $shm_ba_user_settings['user_data'] >
	>
	type $shm_ba_user_settings__scope_shm_dashboard_admin_user_dashboards_184 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_ba_user_settings['scope'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_185 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_186 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['mention_stats_task_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_187 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_188 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_ba_mention_stats_task__task_id_shm_dashboard_admin_user_dashboards_189 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['selected_mention_stats_task_id'] >
		,
		ReturnType< $shm_ba_mention_stats_task['task_id'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_190 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['log_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_191 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_shm_dashboard_admin_user_dashboards_192 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['dashboard_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_193 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_194 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_check_box__checked_shm_dashboard_admin_user_dashboards_195 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['dashboard_user_checked'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_check_box__label_shm_dashboard_admin_user_dashboards_196 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_check_box['label'] >
	>
	type $mol_check_box__title_shm_dashboard_admin_user_dashboards_197 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['dashboard_tag_title'] >
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_dashboard_admin_user_dashboards_198 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['dashboard_tag_checked'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_check_box__title_shm_dashboard_admin_user_dashboards_199 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_dashboard_admin_user_dashboards_200 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['dashboard_tags_all_checked'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_201 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_check_box__title_shm_dashboard_admin_user_dashboards_202 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['upload_tag_title'] >
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_dashboard_admin_user_dashboards_203 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['upload_tag_checked'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_list__rows_shm_dashboard_admin_user_dashboards_204 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['file_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_205 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__title_shm_dashboard_admin_user_dashboards_206 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_dashboard_admin_user_dashboards_207 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['more'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_208 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_209 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_210 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_shm_dashboard_admin_user_dashboards_211 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['log_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_button_minor__title_shm_dashboard_admin_user_dashboards_212 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_dashboard_admin_user_dashboards_213 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['log_more'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_214 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_215 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_216 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['wordstat_content_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_ba_user_settings__user_id_shm_dashboard_admin_user_dashboards_217 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['active_user_id'] >
		,
		ReturnType< $shm_ba_user_settings['user_id'] >
	>
	type $shm_ba_user_settings__user_data_shm_dashboard_admin_user_dashboards_218 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['active_user_data'] >
		,
		ReturnType< $shm_ba_user_settings['user_data'] >
	>
	type $shm_ba_user_settings__scope_shm_dashboard_admin_user_dashboards_219 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_ba_user_settings['scope'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_220 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_221 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_222 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_user_dashboards_223 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_wordstat_dashboard__dashboard_id_shm_dashboard_admin_user_dashboards_224 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['selected_wordstat_task_id'] >
		,
		ReturnType< $shm_wordstat_dashboard['dashboard_id'] >
	>
	type $shm_wordstat_dashboard__user_id_shm_dashboard_admin_user_dashboards_225 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards['active_user_id'] >
		,
		ReturnType< $shm_wordstat_dashboard['user_id'] >
	>
	type $shm_wordstat_dashboard__administrating_shm_dashboard_admin_user_dashboards_226 = $mol_type_enforce<
		boolean
		,
		ReturnType< $shm_wordstat_dashboard['administrating'] >
	>
	export class $shm_dashboard_admin_user_dashboards extends $mol_page {
		page_title( ): string
		active_user_id( ): string
		Copy_id( ): $shm_button_copy
		active_user_email( ): string
		Copy_email( ): $shm_button_copy
		section_mode( next?: string ): string
		Section_switch( ): $mol_switch
		selected_user_id( next?: string ): string
		user_options( ): Record<string, any>
		User_select( ): $mol_select
		User_label( ): $mol_labeler
		section_content( ): readonly(any)[]
		Section_content( ): $mol_view
		active_user_data( ): any
		Monitoring_user_settings( ): $shm_ba_user_settings
		dashboard_create_enabled( ): boolean
		dashboard_create( next?: any ): any
		Dashboard_create( ): $mol_button_major
		dashboard_query( next?: string ): string
		Dashboard_search( ): $mol_search
		dashboard_toolbar_rows( ): readonly(any)[]
		Toolbar( ): $mol_view
		body_rows( ): readonly(any)[]
		Dashboard_list( ): $mol_list
		Agent_user_settings( ): $shm_ba_user_settings
		mention_stats_content_rows( ): readonly(any)[]
		mention_stats_create( next?: any ): any
		Mention_stats_create( ): $mol_button_major
		mention_stats_task_rows( ): readonly(any)[]
		mention_stats_task_title_draft( id: any, next?: string ): string
		mention_stats_task_title_commit( id: any, next?: any ): any
		mention_stats_task_title_keydown( id: any, next?: any ): any
		Mention_stats_task_title( id: any): $mol_string_button
		mention_stats_task_open( id: any, next?: any ): any
		Mention_stats_task_open( id: any): $mol_button_minor
		mention_stats_task_delete_showed( id: any, next?: boolean ): boolean
		Mention_stats_task_delete_icon( id: any): $mol_icon_trash_can
		Mention_stats_task_delete_text( id: any): $mol_view
		mention_stats_task_delete( id: any, next?: any ): any
		Mention_stats_task_delete_yes( id: any): $mol_button_minor
		mention_stats_task_delete_cancel( id: any, next?: any ): any
		Mention_stats_task_delete_no( id: any): $mol_button_minor
		Mention_stats_task_delete_confirm( id: any): $mol_view
		Mention_stats_task_delete( id: any): $mol_pick
		selected_mention_stats_task_id( ): string
		log_content( ): readonly(any)[]
		dashboard_rows( id: any): readonly(any)[]
		dashboard_title_draft( id: any, next?: string ): string
		dashboard_title_commit( id: any, next?: any ): any
		dashboard_title_keydown( id: any, next?: any ): any
		Dashboard_title( id: any): $mol_string_button
		csv_to_duckdb_title( id: any): string
		csv_to_duckdb_enabled( id: any): boolean
		csv_to_duckdb_files( id: any, next?: readonly(File)[] ): readonly(File)[]
		Csv_to_duckdb( id: any): $shm_button_open
		dashboard_access_showed( id: any, next?: boolean ): boolean
		dashboard_access_outside_listener( id: any): any
		dashboard_access_title( id: any): string
		dashboard_user_rows( id: any): readonly(any)[]
		Dashboard_access_bubble( id: any): $mol_list
		Dashboard_access( id: any): $mol_pick
		dashboard_tags_showed( id: any, next?: boolean ): boolean
		dashboard_tags_outside_listener( id: any): any
		dashboard_tags_title( id: any): string
		dashboard_tags_rebuild_title( id: any): string
		dashboard_tags_rebuild_enabled( id: any): boolean
		dashboard_tags_rebuild( id: any, next?: any ): any
		Dashboard_tags_rebuild( id: any): $mol_button_major
		dashboard_tag_rows( id: any): readonly(any)[]
		Dashboard_tags_bubble( id: any): $mol_list
		Dashboard_tags( id: any): $mol_pick
		dashboard_delete_showed( id: any, next?: boolean ): boolean
		dashboard_delete_outside_listener( id: any): any
		Dashboard_delete_icon( id: any): $mol_icon_trash_can
		Dashboard_delete_text( id: any): $mol_view
		dashboard_delete( id: any, next?: any ): any
		Dashboard_delete_yes( id: any): $mol_button_minor
		dashboard_delete_cancel( id: any, next?: any ): any
		Dashboard_delete_no( id: any): $mol_button_minor
		Dashboard_delete_bubble( id: any): $mol_view
		Dashboard_delete( id: any): $mol_pick
		dashboard_rebuild_status_text( id: any): string
		dashboard_user_checked( id: any, next?: boolean ): boolean
		dashboard_user_title( id: any): string
		dashboard_tag_title( id: any): string
		dashboard_tag_checked( id: any, next?: boolean ): boolean
		dashboard_tags_all_checked( id: any, next?: boolean ): boolean
		Upload_tags_title( id: any): $mol_view
		upload_tag_rows( id: any): readonly(any)[]
		Upload_tags_list( id: any): $mol_list
		upload_confirm( id: any, next?: any ): any
		Upload_tags_confirm( id: any): $mol_button_major
		upload_cancel( id: any, next?: any ): any
		Upload_tags_cancel( id: any): $mol_button_minor
		Upload_tags_actions( id: any): $mol_view
		upload_tag_title( id: any): string
		upload_tag_checked( id: any, next?: boolean ): boolean
		file_rows( id: any): readonly(any)[]
		file_title_draft( id: any, next?: string ): string
		file_title_commit( id: any, next?: any ): any
		file_title_keydown( id: any, next?: any ): any
		File_title_text( id: any): $mol_string_button
		file_name( id: any): string
		File_name( id: any): $mol_view
		file_last_day( id: any): string
		File_last_day( id: any): $mol_view
		File_info( id: any): $mol_view
		File_title( id: any): $mol_view
		file_append_title( id: any): string
		file_append_enabled( id: any): boolean
		file_append_files( id: any, next?: readonly(File)[] ): readonly(File)[]
		File_append( id: any): $shm_button_open
		auto_update_showed( id: any, next?: boolean ): boolean
		auto_update_outside_listener( id: any): any
		auto_update_title( id: any): string
		auto_update_dashboard_title( id: any): string
		Auto_update_dashboard( id: any): $mol_view
		auto_update_daily_draft( id: any, next?: string ): string
		Auto_update_daily( id: any): $mol_string
		Auto_update_daily_label( id: any): $mol_labeler
		auto_update_weekly_draft( id: any, next?: string ): string
		Auto_update_weekly( id: any): $mol_string
		Auto_update_weekly_label( id: any): $mol_labeler
		auto_update_monthly_draft( id: any, next?: string ): string
		Auto_update_monthly( id: any): $mol_string
		Auto_update_monthly_label( id: any): $mol_labeler
		auto_update_save_enabled( id: any): boolean
		auto_update_save( id: any, next?: any ): any
		Auto_update_save( id: any): $mol_button_major
		auto_update_run_enabled( id: any): boolean
		auto_update_run( id: any, next?: any ): any
		Auto_update_run( id: any): $mol_button_minor
		auto_update_disable_enabled( id: any): boolean
		auto_update_disable( id: any, next?: any ): any
		Auto_update_disable( id: any): $mol_button_minor
		Auto_update_actions( id: any): $mol_view
		Auto_update_form( id: any): $mol_view
		Auto_update( id: any): $shm_dashboard_admin_user_dashboards_auto_update
		file_delete_showed( id: any, next?: boolean ): boolean
		file_delete_outside_listener( id: any): any
		File_delete_icon( id: any): $mol_icon_trash_can
		File_delete_text( id: any): $mol_view
		file_delete( id: any, next?: any ): any
		File_delete_yes( id: any): $mol_button_minor
		file_delete_cancel( id: any, next?: any ): any
		File_delete_no( id: any): $mol_button_minor
		File_delete_bubble( id: any): $mol_view
		File_delete( id: any): $mol_pick
		File_actions( id: any): $mol_view
		more( next?: any ): any
		Log_head_created( ): $mol_view
		Log_head_event( ): $mol_view
		Log_head_url( ): $mol_view
		Log_head_user_agent( ): $mol_view
		log_created( id: any): string
		Log_created( id: any): $mol_view
		log_event( id: any): string
		Log_event( id: any): $mol_view
		log_url( id: any): string
		Log_url( id: any): $mol_view
		log_user_agent( id: any): string
		Log_user_agent( id: any): $mol_view
		log_rows( ): readonly(any)[]
		log_more( next?: any ): any
		wordstat_content_rows( ): readonly(any)[]
		wordstat_create( next?: any ): any
		Wordstat_create( ): $mol_button_major
		Wordstat_head_title( ): $mol_view
		Wordstat_head_queries( ): $mol_view
		Wordstat_head_subtasks( ): $mol_view
		Wordstat_head_period( ): $mol_view
		Wordstat_head_daily( ): $mol_view
		Wordstat_head_actions( ): $mol_view
		Wordstat_table_head( ): $mol_view
		wordstat_task_rows( ): readonly(any)[]
		Wordstat_rows( ): $mol_list
		wordstat_task_title_draft( id: any, next?: string ): string
		wordstat_task_title_commit( id: any, next?: any ): any
		wordstat_task_title_keydown( id: any, next?: any ): any
		Wordstat_task_title( id: any): $mol_string_button
		wordstat_task_queries( id: any): string
		Wordstat_task_queries( id: any): $mol_view
		wordstat_task_subtasks( id: any): string
		Wordstat_task_subtasks( id: any): $mol_view
		wordstat_task_period( id: any): string
		Wordstat_task_period( id: any): $mol_view
		wordstat_task_daily( id: any, next?: boolean ): boolean
		Wordstat_task_daily( id: any): $mol_check_box
		wordstat_task_open( id: any, next?: any ): any
		Wordstat_task_open( id: any): $mol_button_minor
		wordstat_task_delete_showed( id: any, next?: boolean ): boolean
		Wordstat_task_delete_icon( id: any): $mol_icon_trash_can
		Wordstat_task_delete_text( id: any): $mol_view
		wordstat_task_delete( id: any, next?: any ): any
		Wordstat_task_delete_yes( id: any): $mol_button_minor
		wordstat_task_delete_cancel( id: any, next?: any ): any
		Wordstat_task_delete_no( id: any): $mol_button_minor
		Wordstat_task_delete_confirm( id: any): $mol_view
		Wordstat_task_delete( id: any): $mol_pick
		Wordstat_task_actions( id: any): $mol_view
		selected_wordstat_task_id( ): string
		user_id( ): string
		title( ): ReturnType< $shm_dashboard_admin_user_dashboards['page_title'] >
		Title( ): $mol_view
		tools( ): readonly(any)[]
		body( ): readonly(any)[]
		Monitoring_content( ): $mol_view
		Agent_content( ): $mol_view
		Mention_stats_content( ): $mol_view
		Mention_stats_user_settings( ): $shm_ba_user_settings
		Mention_stats_toolbar( ): $mol_view
		Mention_stats_list( ): $mol_view
		Mention_stats_task( id: any): $mol_view
		Mention_stats_empty( ): $mol_view
		Mention_stats_dashboard( ): $shm_ba_mention_stats_task
		Logs_content( ): $mol_view
		Empty( ): $mol_view
		Dashboard( id: any): $mol_list
		Dashboard_head( id: any): $mol_view
		Dashboard_rebuild_status( id: any): $mol_view
		Dashboard_user( id: any): $mol_check_box
		Dashboard_tag( id: any): $mol_check_box
		Dashboard_tags_all( id: any): $mol_check_box
		Upload_tags( id: any): $mol_view
		Upload_tag( id: any): $mol_check_box
		Files( id: any): $mol_list
		File( id: any): $mol_view
		More( id: any): $mol_button_minor
		Log_head( ): $mol_view
		Log_row( id: any): $mol_view
		No_logs( ): $mol_view
		Log_list( ): $mol_list
		Log_more( ): $mol_button_minor
		No_files( id: any): $mol_view
		No_dashboards( ): $mol_view
		Wordstat_content( ): $mol_view
		Wordstat_user_settings( ): $shm_ba_user_settings
		Wordstat_toolbar( ): $mol_view
		Wordstat_list( ): $mol_view
		Wordstat_task( id: any): $mol_view
		Wordstat_empty( ): $mol_view
		Wordstat_dashboard( ): $shm_wordstat_dashboard
	}
	
}

//# sourceMappingURL=dashboards.view.tree.d.ts.map